/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';

import * as commonSagas from '../_common/commonSagas';
import * as destPointSlice from './destPointSlice';

export default function* watchDestPointSaga() {
 yield takeLatest(destPointSlice.getTableStart.type, commonSagas.getTable);
 yield takeLatest(destPointSlice.getItemStart.type, commonSagas.getItem);
 yield takeLatest(destPointSlice.createItemStart.type, commonSagas.createItem);
 yield takeLatest(destPointSlice.updateItemStart.type, commonSagas.updateItem);
 yield takeLatest(destPointSlice.deleteItemStart.type, commonSagas.deleteItem);
 yield takeLatest(
  destPointSlice.getTableStructureStart.type,
  commonSagas.getTableStructure,
 );
 yield takeLatest(
  destPointSlice.getItemDocumentsStart.type,
  commonSagas.getItemDocuments,
 );
 yield takeLatest(
  destPointSlice.uploadItemDocumentsStart.type,
  commonSagas.uploadItemDocuments,
 );
 yield takeLatest(
  destPointSlice.deleteItemDocumentStart.type,
  commonSagas.deleteItemDocument,
 );
 yield takeLatest(
  destPointSlice.getTableExcelStart.type,
  commonSagas.getTableExcel,
 );
}

